import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.attrs.manage_productization_title"))),
      ]),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(VBreadcrumbs, {
                  staticClass: "pa-0",
                  attrs: { items: _vm.getBreadcrumbs },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "btn-inca-secondary",
                    attrs: { icon: "" },
                    on: { click: _vm.refreshClick },
                  },
                  [_c(VIcon, [_vm._v("mdi-refresh")])],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        VRow,
        {
          class: {
            "flex-filter": _vm.size_screen == "sm" || _vm.size_screen == "xs",
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex-filter-order1", class: _vm.getClassTable },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    staticClass: "text-center table-inca",
                    attrs: {
                      responsive: "",
                      hover: "",
                      items: _vm.items,
                      headers: _vm.headers,
                      loading: _vm.isLoading,
                      search: _vm.search,
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.fecha_creacion",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(item.fecha_creacion)) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.estado",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VChip,
                              {
                                attrs: {
                                  small: "",
                                  "text-color": _vm.getUseCaseStatus(
                                    item.estado
                                  ).textColor,
                                  color: _vm.getUseCaseStatus(item.estado)
                                    .color,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getUseCaseStatus(item.estado).status
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.action",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            item.estado == 16
                              ? _c(
                                  VBtn,
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewDetail(item)
                                      },
                                    },
                                  },
                                  [_c(VIcon, [_vm._v(" mdi-check-all ")])],
                                  1
                                )
                              : _vm._e(),
                            item.estado != 16
                              ? _c(
                                  VBtn,
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewDetailExport(item)
                                      },
                                    },
                                  },
                                  [_c(VIcon, [_vm._v(" mdi-eye ")])],
                                  1
                                )
                              : _vm._e(),
                            _vm.domain === "intercorp.com.pe" &&
                            item.estado != 21
                              ? _c(
                                  VBtn,
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.pausedUsecase(item)
                                      },
                                    },
                                  },
                                  [_c(VIcon, [_vm._v(" mdi-cancel ")])],
                                  1
                                )
                              : _vm._e(),
                            _vm.domain === "intercorp.com.pe" &&
                            item.estado != 21
                              ? _c(
                                  VBtn,
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.observedUsecase(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(VIcon, [
                                      _vm._v(" mdi-alert-circle-outline "),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("pagination-vue", {
                    attrs: { pagination: _vm.pagination },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.filter_enabled
            ? _c(
                "div",
                {
                  staticClass: "col-md-3 col-sm-12 mb-3",
                  class: {
                    "pl-0": _vm.size_screen == "md" || _vm.size_screen == "lg",
                  },
                },
                [
                  _c(
                    VCard,
                    { staticClass: "filters-inca" },
                    [
                      _c(
                        VCardTitle,
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              _vm.collapse_filter = !_vm.collapse_filter
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                      ),
                      _c(
                        VCardText,
                        { staticClass: "pa-2 pt-0" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: "Caso de Uso",
                                      placeholder: "Caso de Uso",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.use_case,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "use_case", $$v)
                                      },
                                      expression: "filters.use_case",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: "Segmento",
                                      placeholder: "Segmento",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.segment,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "segment", $$v)
                                      },
                                      expression: "filters.segment",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      label: "Tipo",
                                      placeholder: "Tipo",
                                      outlined: "",
                                      dense: "",
                                      items: _vm.TYPES_EXPORT_ATTRIBUTES,
                                    },
                                    model: {
                                      value: _vm.filters.type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "type", $$v)
                                      },
                                      expression: "filters.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      label: "Estado",
                                      placeholder: "Estado",
                                      outlined: "",
                                      dense: "",
                                      items: _vm.STATUS_ATTRIBUTES,
                                    },
                                    model: {
                                      value: _vm.filters.estado,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "estado", $$v)
                                      },
                                      expression: "filters.estado",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      label: "Ambiente",
                                      placeholder: "Ambiente",
                                      outlined: "",
                                      dense: "",
                                      items: _vm.ENVIRONMENT_ATTRIBUTES,
                                    },
                                    model: {
                                      value: _vm.filters.ambiente,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "ambiente", $$v)
                                      },
                                      expression: "filters.ambiente",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "default mr-1",
                                      attrs: { outlined: "" },
                                      on: { click: _vm.onLimpiar },
                                    },
                                    [_vm._v(" " + _vm._s(_vm.$t("btns.clean")))]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "primary ",
                                      on: { click: _vm.onBuscar },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("btns.search"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("dialogs-component", {
        ref: _vm.DIALOG_VIEW,
        attrs: {
          title: "Detalle",
          "show-buttons": true,
          "show-cancel-button": false,
          width: 800,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("form_attrs_productize_usecase.use_case")
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "4" } },
                      [
                        _c(VTextField, {
                          staticClass: "pl-0 pl-md-0",
                          attrs: {
                            dense: "",
                            outlined: "",
                            name: "form.selected_use_case",
                            required: "",
                            autocomplete: "off",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.selected_use_case,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "selected_use_case", $$v)
                            },
                            expression: "form.selected_use_case",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "form_attrs_productize_usecase.type_export"
                              )
                            ) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "4" } },
                      [
                        _c(VTextField, {
                          staticClass: "pl-0 pl-md-0",
                          attrs: {
                            dense: "",
                            outlined: "",
                            name: "form.type_export",
                            required: "",
                            disabled: "",
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.form.type_export,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type_export", $$v)
                            },
                            expression: "form.type_export",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("form_attrs_productize_usecase.table_name")
                            ) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "4" } },
                      [
                        _c(VTextField, {
                          staticClass: "pl-0 pl-md-0",
                          attrs: {
                            dense: "",
                            outlined: "",
                            name: "form.segment",
                            required: "",
                            autocomplete: "off",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.segment,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "segment", $$v)
                            },
                            expression: "form.segment",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "form_attrs_productize_usecase.description_table"
                              )
                            ) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "4" } },
                      [
                        _c(VTextarea, {
                          staticClass: "pl-0 pl-md-0",
                          attrs: {
                            dense: "",
                            outlined: "",
                            name: "textarea",
                            required: "",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "description", $$v)
                            },
                            expression: "form.description",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("form_attrs_productize_usecase.user")
                            ) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "4" } },
                      [
                        _c(VTextField, {
                          staticClass: "pl-0 pl-md-0",
                          attrs: {
                            dense: "",
                            outlined: "",
                            name: "form_user",
                            required: "",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.user,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "user", $$v)
                            },
                            expression: "form.user",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("form_attrs_productize_usecase.date_hour")
                            ) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "4" } },
                      [
                        _c(VTextField, {
                          staticClass: "pl-0 pl-md-0",
                          attrs: {
                            dense: "",
                            outlined: "",
                            name: "form_date_hour",
                            required: "",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.date_hour,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "date_hour", $$v)
                            },
                            expression: "form.date_hour",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.form.type_export_id !== 4
                      ? _c(
                          VCol,
                          { attrs: { cols: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "form_attrs_productize_usecase.frecuency"
                                    )
                                  ) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.form.type_export_id !== 4
                      ? _c(
                          VCol,
                          { attrs: { cols: "4" } },
                          [
                            _vm.form.type_export_id !== 4
                              ? _c(VTextField, {
                                  staticClass: "pl-0 pl-md-0",
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    name: "form_frecuency",
                                    required: "",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.form.frequency,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "frequency", $$v)
                                    },
                                    expression: "form.frequency",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.form.type_export_id !== 4
                      ? _c(
                          VCol,
                          { attrs: { cols: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("form_attrs_productize_usecase.day")
                                  ) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.form.type_export_id !== 4
                      ? _c(
                          VCol,
                          { attrs: { cols: "4" } },
                          [
                            _vm.form.type_export_id !== 4
                              ? _c(VTextField, {
                                  staticClass: "pl-0 pl-md-0",
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    name: "form_day",
                                    required: "",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.form.day,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "day", $$v)
                                    },
                                    expression: "form.day",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      VCol,
                      { attrs: { cols: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "form_attrs_productize_usecase.download_file"
                              )
                            ) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          VBtn,
                          {
                            attrs: { icon: "", color: "primary" },
                            on: { click: _vm.downloadSql },
                          },
                          [_c(VIcon, [_vm._v("mdi-download")])],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "4" } },
                      [
                        _c(VCheckbox, {
                          staticClass: "mb-2",
                          attrs: {
                            label: "Tiene formato PLS",
                            outlined: "",
                            dense: "",
                            "hide-details": "auto",
                            readonly: "",
                          },
                          model: {
                            value: _vm.form.has_pls,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "has_pls", $$v)
                            },
                            expression: "form.has_pls",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "form_attrs_productize_usecase.response_text"
                              )
                            ) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "10" } },
                      [
                        _c(VTextarea, {
                          staticClass: "pl-0 pl-md-0",
                          attrs: {
                            dense: "",
                            outlined: "",
                            name: "textarea",
                            required: "",
                          },
                          model: {
                            value: _vm.form.response_text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "response_text", $$v)
                            },
                            expression: "form.response_text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "orange", outlined: "" },
                    on: { click: _vm.deny },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("mdi-cancel"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("form_attrs_productize_usecase.deny")) +
                        " "
                    ),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  { attrs: { color: "primary" }, on: { click: _vm.approve } },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("mdi-check"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("form_attrs_productize_usecase.approve")
                        ) +
                        " "
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: "DIALOG_DETAIL_EXPORT",
        attrs: { title: "Detalle de Exportación", width: 1200 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("ProductizeTransformedAttributeDetail", {
                  attrs: { item: _vm.selected },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogPauseUseCase",
        attrs: {
          title: "Pausar Caso de Uso",
          text: "¿Esta seguro que desea pausar el caso de uso?",
        },
        on: { onConfirm: _vm.onConfirmPause },
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogObservedUseCase",
        attrs: {
          title: "Observar Caso de Uso",
          text: "¿Esta seguro que desea observar el caso de uso?",
        },
        on: { onConfirm: _vm.onConfirmObserved },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }